import * as React from 'react';

function SvgNote(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.813 3.224v3.747h3.234a2 2 0 00-.53-1.013l-2.425-2.495a1.997 1.997 0 00-.28-.239zm-1.636-.367v4.387c0 .753.61 1.363 1.363 1.363h3.543v6.06a2 2 0 01-2 2H6a2 2 0 01-2-2v-9.81a2 2 0 012-2h5.177z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgNote;
